import React from "react";
import { useParams, Navigate, Outlet } from "react-router-dom";
import { connect } from "react-redux";
import config from "../config/config.json";
import { getActivePermissionAccess } from "./moduleAccess";
import { buildDashboardPath } from "../hooks/useDashboardPath";

const VIEW_TO_PERMISSION = {
  create: "write",
  edit: "write",
  show: "read",
};

function getPermissionNameForCard(cardRouting) {
  const cardConfig = config.cards.find((c) => c.routing === cardRouting);
  return cardConfig?.permissionName || null;
}

function RequireViewPermission({ usersReducer, children }) {
  const { card, views } = useParams();
  const userPermissions = usersReducer?.resultsUserPermissions || {};
  const isPermissionsLoaded = !!userPermissions?.uuid;

  const permissionName = getPermissionNameForCard(card);

  if (!permissionName) {
    return children || <Outlet />;
  }

  if (!isPermissionsLoaded) {
    return null;
  }

  const permissionAction = VIEW_TO_PERMISSION[views];

  const permissionNames = permissionName.split(",").map(p => p.trim());
  const hasAccess = permissionNames.some((perm) => {
    return permissionAction
      ? getActivePermissionAccess(userPermissions, `${perm}/${permissionAction}`)
      : getActivePermissionAccess(userPermissions, perm);
  });

  if (!hasAccess) {
    return <Navigate to={buildDashboardPath("")} replace />;
  }

  return children || <Outlet />;
}

const mapStateToProps = (state) => ({
  usersReducer: state.usersReducer,
});

export default connect(mapStateToProps)(RequireViewPermission);
